import { Component, Fragment } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";



import HrShape from "../component/layout/hrshape";

import BannerSection from "../component/section/banner";

import CtaSection from "../component/section/cta";

import PlayerSection from "../component/section/player";
import ProductSection from "../component/section/product";
import SponsorSection from "../component/section/sponsor";
import TestimonialSection from "../component/section/testimonial";
import VideoSection from "../component/section/video";




class HomePage extends Component {
    render() { 
        return (
            <Fragment>
                <Header />
                <BannerSection />
                <ProductSection />
                <TestimonialSection />                                
            
                <PlayerSection />
                <SponsorSection />    
                <VideoSection />                                                                                     
                <HrShape />
                <Footer />
            </Fragment>
        );
    }
}
 
export default HomePage;